import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Head from '../../../layout/head/Head';
import { Block, BlockBetween, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableBody, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import Content from '../../../layout/content/Content';
import { Link, useParams } from 'react-router-dom';
import { Badge, DropdownItem, DropdownMenu, DropdownToggle, Spinner, UncontrolledDropdown } from 'reactstrap';
import { BiErrorCircle } from 'react-icons/bi';
import CardTabs from '../components/cards/CardTabs';
import { employee_dashboard_actions_helper } from '../../../actions/actions_helper';
import { fail_retrieve_specific_grn_schedule_details, loading_retrieve_specific_grn_schedule_details, reset_retrieve_specific_grn_schedule_details, success_retrieve_specific_grn_schedule_details } from '../../../reducers/dashboard_reducers/warehouse/retrieve_specific_grn_schedule_details_Slice';
import { RETRIEVE_SPECIFIC_GRN_SCHEDULE_DETAILS_ACCESS_DENIED_MSG, RETRIEVE_SPECIFIC_GRN_SCHEDULE_DETAILS_ERR_MSG, RETRIEVE_SPECIFIC_GRN_SCHEDULE_DETAILS_SUCCESS_MSG } from '../../../constants/success_error_messages_consts';
import * as app_consts from "../../../constants/react_app_consts";
import { RETRIEVE_SPECIFIC_GRN_SCHEDULER_DETAILS_API } from '../../../api/api_data';
import { messageToast } from '../../../utils/Utils';
import { useSelector } from 'react-redux';
import moment from 'moment/moment';
import ViewSpecificGRNScheduleDetails from '../components/modal/ViewSpecificGRNScheduleDetails';

const GRNSchedulerDetails = () => {

  const { name } = useParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [activeCardTab, setActiveCardTab] = useState("Main Info");
  const [uag_consigments, setUagConsigments] = useState([]);
  const [direct_delivery_consignments, setDirectDeliveryConsignment] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [sm, updateSm] = useState(false);
  const [selectedViewConsignmentsList, setSelectedViewConsignmentsList] = useState("All");
  const [view_consignment_modal, setViewConsignmentModal] = useState(false);
  const [selected_consigment, setSelectedConsignment] = useState("");



  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    // Dispatch
    retrieve_schedule_details();
  }, []);

  const retrieve_schedule_details = () => {
    dispatch(
      employee_dashboard_actions_helper(
        loading_retrieve_specific_grn_schedule_details,
        success_retrieve_specific_grn_schedule_details,
        fail_retrieve_specific_grn_schedule_details,
        RETRIEVE_SPECIFIC_GRN_SCHEDULE_DETAILS_ERR_MSG,
        RETRIEVE_SPECIFIC_GRN_SCHEDULE_DETAILS_SUCCESS_MSG,
        app_consts.GET,
        `${RETRIEVE_SPECIFIC_GRN_SCHEDULER_DETAILS_API}${name}`,
        null,
        RETRIEVE_SPECIFIC_GRN_SCHEDULE_DETAILS_ACCESS_DENIED_MSG
      )
    );
  };

  // Listen to Reducer
  const retrieve_specific_grn_schedule_details_listener = useSelector((state) => state.retrieve_specific_grn_schedule_details.retrieve_specific_grn_schedule_details);
  // 
  useEffect(() => {
    if (retrieve_specific_grn_schedule_details_listener.status !== app_consts.IDLE)
    {
      if (retrieve_specific_grn_schedule_details_listener.status === app_consts.LOADING)
      {
        setError("");
        setLoading(true);
      } else
      {
        setLoading(false);
        if (retrieve_specific_grn_schedule_details_listener.status === app_consts.FAIL)
        {
          setError(retrieve_specific_grn_schedule_details_listener.message);
          messageToast(retrieve_specific_grn_schedule_details_listener.message, app_consts.FAIL);
        } else if (retrieve_specific_grn_schedule_details_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_specific_grn_schedule_details_listener.data);
          setCurrentPageData(retrieve_specific_grn_schedule_details_listener.data);

          const in_consigments = retrieve_specific_grn_schedule_details_listener.data?.filter((filt_data) => app_consts.UAG_CONSIGMENTS === filt_data?.offload_point);
          const out_consigments = retrieve_specific_grn_schedule_details_listener.data?.filter((filt_data) => app_consts.UAG_CONSIGMENTS !== filt_data?.offload_point);

          setUagConsigments(in_consigments);
          setDirectDeliveryConsignment(out_consigments);
        }
        dispatch(reset_retrieve_specific_grn_schedule_details());
      }
    }
  }, [retrieve_specific_grn_schedule_details_listener]);

  const tabs = [
    {
      tabName: "Main Info"
    },
    {
      tabName: "Consignments"
    },
  ];

  const toggleConsigmentList = (value) => {
    if (value === "Direct Delivery Consignments")
    {
      setCurrentPageData(direct_delivery_consignments);
    }
    else if (value === "UAG Consignments")
    {
      setCurrentPageData(uag_consigments);
    }
    else if (value === "All")
    {
      setCurrentPageData(page_data);
    }
    setSelectedViewConsignmentsList(value);
  };

  const open_view_consignment_modal = (sent_id) => {
    setSelectedConsignment(sent_id);
    setViewConsignmentModal(true);
  };

  const clost_view_consignment_modal = () => {
    setViewConsignmentModal(false);
  };



  return (
    <>
      <Head title="GRN Schedule Details" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="g-3">
            <BlockHeadContent>
              <BlockTitle>GRN Schedule Details</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <Link to={`${process.env.PUBLIC_URL}/dashboard/grn_schedule`}>
                <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                  <Icon name="arrow-left"></Icon>
                  <span>Back</span>
                </Button>
              </Link>
              <Link to={`${process.env.PUBLIC_URL}/dashboard/grn_schedule`}>
                <Button color="light" outline className="btn-icon bg-white d-inline-flex d-sm-none">
                  <Icon name="arrow-left"></Icon>
                </Button>
              </Link>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <div className='p-5 d-flex align-center justify-center'>
                <Spinner />
              </div>
            </>
            :
            <>
              {
                error ?
                  <>
                    <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                      <BiErrorCircle className="text-danger fs-3" />
                      <p>{error}</p>
                    </div>
                  </>
                  :
                  <>
                    {
                      page_data && (page_data?.length > 0 || page_data !== null) ?
                        <>
                          <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                          {
                            activeCardTab === "Main Info" && (
                              <>
                                <div className="card-inner bg-white">
                                  <Block>
                                    <BlockHead>
                                      <BlockTitle tag="h5">Main Info</BlockTitle>
                                    </BlockHead>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Name</span>
                                          <span className="profile-ud-value">{page_data?.length > 0 ? page_data[0]?.name : "--"}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Consignments</span>
                                          <span className="profile-ud-value">{page_data?.length || "0"}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">UAG Consignments</span>
                                          <span className="profile-ud-value">{uag_consigments?.length || "0"}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="profile-ud-list">
                                      <div className="profile-ud-item">
                                        <div className="profile-ud wider">
                                          <span className="profile-ud-label">Direct Delivery Consignments</span>
                                          <span className="profile-ud-value">{direct_delivery_consignments?.length || "0"}</span>
                                        </div>
                                      </div>
                                    </div>
                                  </Block>
                                </div>
                              </>
                            )
                          }
                          {
                            activeCardTab === "Consignments" && (
                              <>
                                <div className="card-inner">
                                  <Block>
                                    <BlockBetween className="mb-4">
                                      <BlockHeadContent>
                                        <BlockTitle tag="h5">Consignments</BlockTitle>
                                      </BlockHeadContent>
                                      <BlockHeadContent>
                                        <div className="toggle-wrap nk-block-tools-toggle">
                                          <Button
                                            className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                                            onClick={() => updateSm(!sm)}
                                          >
                                            <Icon name="more-v"></Icon>
                                          </Button>
                                          <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                                            <ul className="nk-block-tools g-3">
                                              <li>
                                                <UncontrolledDropdown>
                                                  <DropdownToggle tag="a" className="dropdown-toggle btn btn-white btn-dim btn-outline-light">
                                                    <span>
                                                      <span className="d-none d-md-inline">{selectedViewConsignmentsList}</span>
                                                    </span>
                                                    <Icon className="dd-indc" name="chevron-right"></Icon>
                                                  </DropdownToggle>
                                                  <DropdownMenu>
                                                    <ul className="link-list-opt no-bdr">
                                                      <li>
                                                        <DropdownItem
                                                          href="#dropdownitem"
                                                          onClick={(ev) => {
                                                            ev.preventDefault();
                                                            toggleConsigmentList("All");
                                                          }}
                                                        >
                                                          All
                                                        </DropdownItem>
                                                      </li>
                                                      <li>
                                                        <DropdownItem
                                                          href="#dropdownitem"
                                                          onClick={(ev) => {
                                                            ev.preventDefault();
                                                            toggleConsigmentList("UAG Consignments");
                                                          }}
                                                        >
                                                          UAG Consignments
                                                        </DropdownItem>
                                                      </li>
                                                      <li>
                                                        <DropdownItem
                                                          href="#dropdownitem"
                                                          onClick={(ev) => {
                                                            ev.preventDefault();
                                                            toggleConsigmentList("Direct Delivery Consignments");
                                                          }}
                                                        >
                                                          Direct Delivery Consignments
                                                        </DropdownItem>
                                                      </li>
                                                    </ul>
                                                  </DropdownMenu>
                                                </UncontrolledDropdown>
                                              </li>
                                            </ul>
                                          </div>
                                        </div>
                                      </BlockHeadContent>
                                    </BlockBetween>
                                  </Block>
                                </div>
                                {
                                  page_data && page_data?.length > 0 ?
                                    <>
                                      <div className="nk-tb-list is-separate is-medium mb-3">
                                        <DataTableBody >
                                          <DataTableHead className="nk-tb-item">
                                            <DataTableRow>
                                              <span className="sub-text">Name</span>
                                            </DataTableRow>
                                            <DataTableRow size="mb">
                                              <span className="sub-text">Horse Reg</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Trailer</span>
                                            </DataTableRow>
                                            <DataTableRow size="lg">
                                              <span className="sub-text">Transporter</span>
                                            </DataTableRow>
                                            <DataTableRow size="lg">
                                              <span className="sub-text">Offload point/Client</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Tonnage</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Offload Tonnage</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Cargo Details</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Date Loaded</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Load Reference</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Created On</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Product Ref</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Status</span>
                                            </DataTableRow>
                                            <DataTableRow size="md">
                                              <span className="sub-text">Action</span>
                                            </DataTableRow>
                                          </DataTableHead>
                                          {currentItems?.length > 0
                                            ? currentItems.map((item) => {
                                              return (
                                                <DataTableItem key={item.grn_schdeule_id}>
                                                  <DataTableRow size="sm">
                                                    <Link onClick={(e) => { e.preventDefault(); open_view_consignment_modal(item.grn_schdeule_id); }} >
                                                      <span className="tb-product">
                                                        <span className="title">{item.name || "--"}</span>
                                                      </span>
                                                    </Link>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.horse_reg || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <div>
                                                      <span className="fw-medium">Trailer 1: </span>
                                                      <span className="tb-sub">{item?.trailer_reg_one || "--"}</span>
                                                    </div>
                                                    <div>
                                                      <span className="fw-medium">Trailer 2: </span>
                                                      <span className="tb-sub">{item?.trailer_reg_two || "--"}</span>
                                                    </div>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.transporter || "--"}</span>
                                                    <div>
                                                      <span className="fw-medium">Driver: </span>
                                                      <span className="tb-sub">{item?.driver || "--"}</span>
                                                    </div>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.offload_point || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.tonnage || "0"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.quantity_offloaded || "0"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.cargo_details || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.data_loaded || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.load_reference || "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.inserted_at ? moment(item?.inserted_at).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow>
                                                    <span className="tb-sub">{item?.product_id ? "Found" : "Not Found"}</span>
                                                  </DataTableRow>
                                                  <DataTableRow size="md">
                                                    <span className="tb-odr-status">
                                                      <Badge
                                                        color="warning"
                                                        className="badge-dot"
                                                      >
                                                        {item?.status?.toUpperCase() || "--"}
                                                      </Badge>
                                                    </span>
                                                  </DataTableRow>
                                                  <DataTableRow className="nk-tb-col-tools">
                                                    <div className="tb-odr-btns d-none d-sm-inline">
                                                      <Link onClick={(e) => { e.preventDefault(); open_view_consignment_modal(item.grn_schdeule_id); }} >
                                                        <Button color="primary" size="sm" className="btn btn-dim">
                                                          View
                                                        </Button>
                                                      </Link>
                                                    </div>
                                                    <Button className="btn-pd-auto d-sm-none">
                                                      <Icon name="chevron-right"></Icon>
                                                    </Button>
                                                  </DataTableRow>
                                                </DataTableItem>
                                              );
                                            })
                                            : null}
                                        </DataTableBody>
                                        {currentItems?.length > 0 && (
                                          <div className="mt-3">
                                            <PaginationComponent
                                              itemPerPage={itemPerPage} Cargo Details

                                              totalItems={current_page_data?.length}
                                              paginate={paginate}
                                              currentPage={currentPage}
                                            />
                                          </div>
                                        )}
                                      </div>
                                    </>
                                    :
                                    <>
                                      <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                                        <BiErrorCircle className="text-danger fs-3" />
                                        <p>No Data Found</p>
                                      </div>
                                    </>
                                }
                                <ViewSpecificGRNScheduleDetails closeModal={clost_view_consignment_modal} isOpen={view_consignment_modal} data={selected_consigment} />
                              </>
                            )
                          }
                        </>
                        :
                        <>
                          <div className="mt-3 p-5 text-soft alert-icon text-center fw-bold fs-15px">
                            <BiErrorCircle className="text-danger fs-3" />
                            <p>No Data Found</p>
                          </div>
                        </>
                    }
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default GRNSchedulerDetails;;